import React, { useState, useEffect } from "react";
import BasedModal, { IProps } from "components/BaseModalComponents/BasedModal";
import { useAppDispatch } from "hooks/redux";
import { updateTickerComment } from "store/reducers/GroupsSlice";
import ModalFooter from "../BaseModalComponents/Footer/ModalFooter";
import { Container, ModalBody, TextArea } from "./styles";

interface EditCommentModalProps extends IProps {
    tickerName: string;
    groupName: string;
    initialComment: string;
}

function EditCommentModal({
    isOpen,
    onRequestClose,
    tickerName,
    groupName,
    initialComment = "",
}: EditCommentModalProps) {
    const dispatch = useAppDispatch();
    const [comment, setComment] = useState(initialComment);

    useEffect(() => {
        if (isOpen) {
            setComment(initialComment);
        }
    }, [isOpen, initialComment]);

    const onApplyClick = () => {
        if (!groupName || !tickerName) {
            onRequestClose?.(undefined as any);  
            return;
        }


        dispatch(updateTickerComment({
            group_name: groupName,
            ticker_name: tickerName,
            comment: comment.trim(),
        }) as any);

        onRequestClose?.(undefined as any);      
    };

    return (
        <BasedModal isOpen={isOpen} onRequestClose={onRequestClose}>
            <Container>
                <ModalBody>
                    <div style={{ marginBottom: "12px", fontWeight: 500 }}>
                        Комментарий к тикеру
                    </div>
                    <div style={{ marginBottom: "8px", color: "#666" }}>
                        {tickerName}
                    </div>

                    <TextArea
                        placeholder="Введите комментарий..."
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        rows={6}
                    />
                </ModalBody>

                <ModalFooter
                    style={{ padding: "7px 11px 10px 15px" }}
                    applyText="Сохранить"
                    onApplyClick={onApplyClick}
                    cancelText="Отменить"
                    onCancelClick={onRequestClose}
                />
            </Container>
        </BasedModal>
    );
}

export default EditCommentModal;